// 审计监控
const auditManagement = () => import(/* webpackChunkName: "identity" */ '../../views/audit/audit'), // 审计管理
    health = () => import(/* webpackChunkName: "identity" */ '../../views/audit/health'), // 健康监控
    tenantMonitoring = () => import(/* webpackChunkName: "identity" */ '../../views/audit/tenant'), // 租户监控
    cluster = () => import(/* webpackChunkName: "identity" */ '../../views/audit/cluster'); // 集群监控

export default [
    {
        path: '/audit/auditManagement',
        name: 'auditManagement',
        meta: { title: '审计管理' },
        component: auditManagement // 审计管理
    },
    {
        path: '/audit/health',
        name: 'health',
        meta: { title: '健康监控' },
        component: health // 健康监控
    },
    {
        path: '/audit/tenantMonitoring',
        name: 'tenantMonitoring',
        meta: { title: '租户监控' },
        component: tenantMonitoring // 租户监控
    },
    {
        path: '/audit/cluster',
        name: 'cluster',
        meta: { title: '集群监控' },
        component: cluster // 集群监控
    }
];
